import React, {useState}  from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { renderStoreName } from '../../../store/util/renderStoreName'
import { cleanPhoneNumber } from '../../../../util/clean-phone-number'
import { getSelectValue } from '../../../../util/select'
import PhysicianSelector from "./PhysicianSelector";
import StoreSelector from "./StoreSelector";
import Select from "../../../form/component/Select";
import WhatsappConfirmationModal from "./WhatsappConfirmationModal";
import Checkbox from '../../../form/component/Checkbox'

const FRESH_DESK_LINK = 'https://gosunshinesmile.freshdesk.com/a/contacts/'
const FRESH_SALES_LINK = 'https://plus-dental.freshsales.io/deals/'
const HUBSPOT_LINK = 'https://app.hubspot.com/contacts/8110222/contact/'

const getSupplierName = (supplierList, supplierId) => {
    const supplier = supplierList.find(({ id }) => id === supplierId)
    return supplier ? supplier.displayName : ''
}

const getPhysicianName = (physicianList, userList, { treatingPhysicianId, partnerPhysicianId }) => {
    if (treatingPhysicianId) {
        const treatingPhysician = userList.find(({ id }) => id === treatingPhysicianId)
        return treatingPhysician ? treatingPhysician.firstName + ' ' + treatingPhysician.lastName : ''
    }
    const partnerPhysician = physicianList.find(({ id }) => id === partnerPhysicianId)
    return partnerPhysician ? partnerPhysician.displayName : ''
}

const getLanguageValue = (languageList, extraLanguages, language) => {
    const extraLanguagesArr = extraLanguages ? Object.keys(extraLanguages) : []

    const filteredLanguageListItems = languageList.filter((item) => {
        return extraLanguagesArr.includes(item.id) || item.id === language
    })

    if (filteredLanguageListItems[0].id === 'en_GB') {
        filteredLanguageListItems.push(filteredLanguageListItems.shift());
    }

    const languagesToBeContacted = filteredLanguageListItems.map((item) => {
        return item.value
    })

    return languagesToBeContacted.join(', ')
}

const WhatsappOptIn = ({customer, currentUser, updateWhatsappOtpIn}) => {

    const whatsappOptInValueList = [
        {
            'id':'true',
            'value':'true',
        },
        {
            'id':'false',
            'value':'false',
        }
    ]

    const readOnly = !currentUser.roleList.includes('customer_service_team_lead');

    const addEmpty = customer.isWhatsAppOptIn === null;

    const [showConfirmationModal, setShowConfirmationModal] = useState(false)

    const [whatsAppOptIn, setWhatsAppOptIn] = useState(false)

    const toggleModalVisibility = () => {
        setShowConfirmationModal(!showConfirmationModal)
    }

    const handleWhatsappOptIn = (name,value) => {
        setWhatsAppOptIn(value)
        toggleModalVisibility()
    }

    return (
        <tr>
            <td>WhatsApp Opt-in</td>
            <td>
                <Select
                    name={'isWhatsAppOptIn'}
                    object={customer}
                    valueList={whatsappOptInValueList}
                    onChange={handleWhatsappOptIn}
                    readOnly={readOnly}
                    addEmpty={addEmpty}
                />
            </td>
            <WhatsappConfirmationModal
                isOpen={showConfirmationModal}
                handleClose={toggleModalVisibility}
                updateWhatsappOtpIn={()=>{updateWhatsappOtpIn(whatsAppOptIn)}}
            />
        </tr>
    )
}

const CustomerInfo = (
    {
        customer,
        salutationList,
        countryCodeList,
        supplierList,
        physicianList,
        userList,
        canReassignPhysician,
        reassignPhysician,
        updateWhatsappOtpIn,
        currentUser,
        storeList,
        reassignStore,
        canReassignStore,
        languageList,
        changeIsTransferredToDrSmile,
    },
) => {
    const phone = cleanPhoneNumber(customer.phone, customer.countryCode)
    const salutation = getSelectValue(salutationList, customer.gender)
    const physicianName = getPhysicianName(physicianList, userList, customer)
    const country = getSelectValue(countryCodeList, customer.countryCode)
    const supplierName = getSupplierName(supplierList, customer.partnerSupplierId)
    const freshSalesDealId = findFreshSalesDealId(customer)
    const onyxId = customer.onyxId
    const onyxServer = customer.onyxServer
    const extraLanguages = getLanguageValue(languageList, customer.extraLanguages, customer.language)

    const [drSmileTransfer, setDrSmileTransfer] = useState(customer.drSmileTransfer)

    const handleIsTransferredToDrSmile = (name, value) => {
        setDrSmileTransfer(value);
        changeIsTransferredToDrSmile(value);
    }

    return (
        <React.Fragment>

            <Row top="M">
                <Column size={4}>
                    <table className="info-table">
                        <tbody>
                        <tr>
                            <td>{salutation + ' ' + customer.firstName + ' ' + customer.lastName}</td>
                        </tr>
                        <tr>
                            <td>{customer.zip || ''} {customer.city || ''}</td>
                        </tr>
                        <tr>
                            <td>{country}</td>
                        </tr>
                        <tr>
                            <td>Languages to be contacted</td>
                            <td>{extraLanguages}</td>
                        </tr>
                        </tbody>
                    </table>

                </Column>
                <Column size={4}>

                    <table className="info-table">
                        <tbody>
                        <tr>
                            <td>Email</td>
                            <td><a href={'mailto:' + customer.email}>{customer.email}</a></td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td><a href={'tel:' + phone}>{phone}</a></td>
                        </tr>
                        <WhatsappOptIn
                            customer={customer}
                            updateWhatsappOtpIn={updateWhatsappOtpIn}
                            currentUser={currentUser}
                        />
                        {customer.freshDeskId && (
                            <tr>
                                <td>Freshdesk</td>
                                <td><a target="_blank" rel="noopener noreferrer" href={FRESH_DESK_LINK + customer.freshDeskId}>view <i className="fa fa-external-link"/></a></td>
                            </tr>
                        )}
                        {freshSalesDealId && (
                            <tr>
                                <td>Freshsales</td>
                                <td><a target="_blank" rel="noopener noreferrer" href={FRESH_SALES_LINK + freshSalesDealId}>view <i className="fa fa-external-link"/></a></td>
                            </tr>
                        )}
                        {customer.hubspotContactId && (
                            <tr>
                                <td>Hubspot</td>
                                <td><a target="_blank" rel="noopener noreferrer" href={HUBSPOT_LINK + customer.hubspotContactId}>view <i className="fa fa-external-link"/></a></td>
                            </tr>
                        )}
                        <tr>
                            <td>Dr. SmileData transfer consent</td>
                            <td>{customer.dataTransferDS ? 'Yes' : 'No'}</td>
                        </tr>
                        <tr>
                            <td>Transferred to Dr. Smile</td>
                            <td>
                                <Checkbox
                                    object={{drSmileTransfer}}
                                    name="drSmileTransfer"
                                    onChange={handleIsTransferredToDrSmile}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Column>


                <Column size={4}>
                    <table className="info-table">
                        <tbody>
                        {customer.voucher && (
                            <tr>
                                <td>Voucher code</td>
                                <td>{customer.voucher.code}</td>
                            </tr>
                        )}
                        <tr>
                            <td>Store</td>
                            <td>{(canReassignStore && customer.store !== '') ? (<StoreSelector
                                customer={customer}
                                reassignStore={reassignStore}
                            />) : (<span className="info-store">{renderStoreName(customer.store)}</span>)}</td>
                        </tr>
                        <tr>
                            <td>Physician</td>
                            <td>{(canReassignPhysician && physicianName !== '') ? (<PhysicianSelector
                                customer={customer}
                                physicianList={physicianList}
                                userList={userList}
                                reassignPhysician={reassignPhysician}
                            />) : (<span className="qa-physician-name">{physicianName}</span>)}</td>
                        </tr>
                        <tr>
                            <td>Supplier</td>
                            <td>{supplierName}</td>
                        </tr>
                        <tr>
                            <td>OnyxId</td>
                            <td>{onyxId}</td>
                        </tr>
                        <tr>
                            <td>OnyxServer</td>
                            <td>{onyxServer}</td>
                        </tr>
                        </tbody>
                    </table>
                </Column>
            </Row>

        </React.Fragment>

    )
}

const findFreshSalesDealId = (customer) => {
    if (!customer.processList) {
        return null;
    }

    let freshSalesDealId = findLatestProcessContextFreshSalesDealId(customer.processList);
    if ('treatmentQuotationList' in customer) {
        freshSalesDealId = freshSalesDealId || findLatestTreatmentQuotationFreshSalesDealId(customer.treatmentQuotationList);
    }

    return freshSalesDealId || null;
}

const findLatestProcessContextFreshSalesDealId = (processList) => {
    let latestTimestamp = 0;
    let latestDealId = '';

    processList.forEach((pi) => {
        if (!pi.context['freshSalesDealId']) {
            return '';
        }

        const processStartTimestamp = Date.parse(pi.started);
        if (processStartTimestamp > latestTimestamp) {
            latestTimestamp = processStartTimestamp;
            latestDealId = pi.context.freshSalesDealId;
        }
    });

    return latestDealId;
}

const findLatestTreatmentQuotationFreshSalesDealId = (treatmentQuotationList) => {
    let latestTimestamp = 0;
    let latestDealId = '';

    treatmentQuotationList.forEach((tq) => {
        if (!tq['freshSalesDealId']) {
            return '';
        }

        const createdAtTimestamp = Date.parse(tq.created);
        if (createdAtTimestamp > latestTimestamp) {
            latestTimestamp = createdAtTimestamp;
            latestDealId = tq.freshSalesDealId;
        }
    });

    return latestDealId;
}

CustomerInfo.propTypes = {
    customer: PropTypes.object.isRequired,
    salutationList: PropTypes.array,
    countryCodeList: PropTypes.array.isRequired,
    canReassignPhysician: PropTypes.bool.isRequired,
    reassignPhysician: PropTypes.func.isRequired,
    reassignStore: PropTypes.func.isRequired,
    languageList: PropTypes.array,
    changeIsTransferredToDrSmile: PropTypes.func.isRequired,
}

export default CustomerInfo



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerInfo.js